export default __webpack_public_path__ + "static/logo-wordmark-black-96cb3d5de373b974c7ae3d244db7da75.png";